import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const FullscreenButtonContainer = styled.button`
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1000;
  background-color: rgba(46, 125, 50, 0.8);
  color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: rgba(46, 125, 50, 1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:focus {
    outline: 2px solid #2e7d32;
    outline-offset: 2px;
  }

  i {
    font-size: 14px;
  }
  
  /* Tooltip on hover */
  &::after {
    content: "Open in full screen";
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    padding: 6px 10px;
    background-color: rgba(0, 0, 0, 0.85);
    color: white;
    font-size: 0.75rem;
    white-space: nowrap;
    border-radius: 4px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
    z-index: 1001;
  }
  
  &:hover::after {
    opacity: 1;
  }
`;

const FullscreenButton = () => {
  const location = useLocation();
  const isEmbedMode = location.pathname.includes("/embed");

  if (!isEmbedMode) {
    return null;
  }

  // Extract the non-embed URL (e.g., /events/my-event/embed -> /events/my-event)
  const fullscreenUrl = location.pathname.replace(/\/embed$/, "");
  if (fullscreenUrl === location.pathname) {
    return null;
  }

  const handleClick = () => {
    window.open(fullscreenUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <FullscreenButtonContainer
      onClick={handleClick}
      aria-label="Open in full screen"
      title="Open in full screen"
    >
      <i className="fas fa-expand"></i>
    </FullscreenButtonContainer>
  );
};

export default FullscreenButton;

